// extracted by mini-css-extract-plugin
export default {"fot_warp":"footer_fot_warp__mTdsh"};